module.exports = __webpack_public_path__ + "static/media/swirly.b4a63156.png";